import Result_new from './Result';

export default Result_new
export { Result_new as Base }
